import { SeasunDcLogger } from '@src/utils/seasundclogger/2.0.2';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { LANGUAGE_NAME } from '@src/utils/locale';
import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
import queryParams from '@src/utils/getAppId';

class Reporter {
  async init() {
    const customConfig = await this.createCustomConfig();
    SeasunDcLogger.config({
      appId: '200001086',
      appVersion: '1.0',
      channel: REPORT_CHANNEL,
      commonAttributes: customConfig
    });
    SeasunDcLogger.start();
  }

  push(log) {
    SeasunDcLogger.push(log);
  }

  getLocalTime(i) {
    if (typeof i !== 'number') return;

    const d = new Date();
    //得到1970年一月一日到现在的秒数
    const len = d.getTime();

    //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
    const offset = d.getTimezoneOffset() * 60000;

    //得到现在的格林尼治时间
    const utcTime = len + offset;

    return new Date(utcTime + 3600000 * i);
  }

  dateFormatter(fmt, date) {
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  }

  getAppid() {
    return queryParams.appId ? queryParams.appId : '';
  }

  async createCustomConfig() {
    // const zoneData = await
    const lang = getLanguageByPath();
    return {
      gameAppId: this.getAppid(),
      batchtimestamp: this.dateFormatter('yyyy-MM-dd hh:mm:ss.S', this.getLocalTime(8)),
      language: LANGUAGE_NAME[lang],
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reference: window.location.href,
      post_url: ZT_ROOT_ADDRESS
    };
  }
}

const dcReport = new Reporter();
export default dcReport;
